/* istanbul ignore file */
import React from "react";
import { ToelichtingPensioenHoofdstuk } from "../../../../../.generated/rapportage/rapportagetypes";
import { InkomensanalyseTabelPensioen } from "../../../scenarios/pensioen-drawer";
import { Chapter } from "../../../components/Chapter";
import Heading from "../../../components/Heading";
import { ReactElement } from "react-markdown/lib/react-markdown";
import { Motivering } from "../../../components/Motivering";

export const ScenarioPensioenChapter = ({
  scenarioPensioen,
  selectedAanvrager,
}: {
  scenarioPensioen: ToelichtingPensioenHoofdstuk;
  selectedAanvrager?: "Aanvrager1" | "Aanvrager2";
}): ReactElement => {
  const dashboardSettings = scenarioPensioen.dashboard?.pensioen;
  const klantVolgNummer = selectedAanvrager === "Aanvrager2" ? 2 : 1;
  const motivering =
    scenarioPensioen.motivering?.find(
      (x) => x.klantVolgnummer === klantVolgNummer
    ) || null;
  const isScenarioForAanvrager1 = selectedAanvrager === "Aanvrager1";

  const pensioner = isScenarioForAanvrager1
    ? motivering?.klantNaamAanvrager || "Aanvrager"
    : motivering?.klantNaamPartner || "Partner";

  const motiveringKeuzes =
    selectedAanvrager === "Aanvrager1"
      ? scenarioPensioen?.motiveringKeuzesAanvrager1
      : scenarioPensioen?.motiveringKeuzesAanvrager2;

  return (
    <Chapter>
      <div className="break-avoid">
        <Heading level={3} text={`Bij pensioen van ${pensioner}`} />
        <Motivering
          wens={motiveringKeuzes?.wensen ?? null}
          advies={motiveringKeuzes?.advies ?? null}
          keuze={motiveringKeuzes?.keuze ?? null}
        />
      </div>
      {motivering && dashboardSettings && (
        <InkomensanalyseTabelPensioen
          motiveringOutput={motivering}
          dashboardSettings={dashboardSettings}
          selectedAanvrager={selectedAanvrager}
        />
      )}
    </Chapter>
  );
};
